<template>
  <div v-scroll="onScroll">
    <v-fab-transition>
      <v-btn color="accent"
             dark
             fixed
             bottom
             right
             fab
             v-show="offsetTop > 400"
             @click="scrollToTop"
             style="bottom: 72px;">
        <v-icon>fas fa-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        offsetTop: window.pageYOffset || document.documentElement.scrollTop
      }
    },
    methods: {
      onScroll () {
        this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
